import StoryBooks from "../data/StoryBooks";
import "./StoryLibrary.css"
import {Link} from "react-router-dom";
import {MobileCollapseSection} from "../Elements/MobileAccordionSection";
import {useEffect, useMemo, useState} from "react";

export const StoryLibrary: React.FC = () => {

    function useMediaQuery(query: string) {
        const getMatch = () =>
            typeof window !== "undefined" && window.matchMedia
                ? window.matchMedia(query).matches
                : false;

        const [matches, setMatches] = useState(getMatch);

        useEffect(() => {
            const mql = window.matchMedia(query);
            const onChange = () => setMatches(mql.matches);

            onChange();
            mql.addEventListener?.("change", onChange);
            return () => mql.removeEventListener?.("change", onChange);
        }, [query]);

        return matches;
    }

    const publishedBooks = StoryBooks.filter(book => book.public).sort();

    const isMdUp = useMediaQuery("(min-width: 768px)");
    const colsPerShelf = isMdUp ? 4 : 3;

    const chunk = <T,>(arr: T[], size: number) =>
        Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
            arr.slice(i * size, i * size + size)
        );

    const rows = useMemo(
        () => chunk(publishedBooks, colsPerShelf),
        [publishedBooks, colsPerShelf]
    );

    return (
        <div className="root">
            <div className="text-center">
                <img src="/identity/SlickStrokeLogo.png" alt="SlickStroke" style={{ width: "200px" }} />
            </div>

            <MobileCollapseSection title="What is this?" startOpen={true}>
                <b className="text-danger">SlickStroke</b> is an ADULT-ONLY typing game, where you type the words as they appear in a story.
                <br />
                Your progress is stored only locally in your browser, and the server makes no effort to track your identity.
            </MobileCollapseSection>

            <MobileCollapseSection title="The Rules" startOpen={false}>
                The rules are simple: you have to type the words as they appear in the story, in the order they appear.
                Each sentence ends in a safepoint. However, if you make mistakes, you will be penalized accordingly outside the game, and if you are unlucky, you will have to start the sentence over.
                <br />
                You will have to earn your smut.
                <br />
                No sound effects, no ads, no quicktime actions.
            </MobileCollapseSection>

            <MobileCollapseSection title="Prototype warning" startOpen={false}>
                It is still in early development, so expect bugs and rough edges. Feel free to report any issues on GitHub.
                <br />
                If you have a story you'd like to contribute to this platform, kindly contact{" "}
                <a href="https://discord.monsterbrothel.com">Gecko the Dev (Discord)</a>.
            </MobileCollapseSection>
            <hr/>
  <div>
      <h2>Story Library</h2>

      {rows.map((group, rowIdx) => (
          <div className="bookshelf-row mb-3" key={rowIdx}>
              <div className="row g-3">
                  {group.map((book) => (
              <div className="col-4 col-md-3" key={book.id}>
                  <div className="bookshelf-slot">
                      <Link to={"/book/"+book.id}>
                      <img
                          src={`/bookcovers/${book.id}.png`}
                          className="bookcover"
                          style={{cursor: "grab"}}
                          alt={book.title}
                          loading="lazy"
                      />
                      <div className="book-title">{book.title}</div>
                      </Link>
                  </div>
              </div>
          ))}
                      </div>

                      <div className="shelf-plank" />
                      </div>
                      ))}
  </div>
  </div>
    );
};
